/**
 * Safely parses a JSON string, returning a fallback value if parsing fails.
 * @param jsonString - The JSON string to parse
 * @param fallback - The fallback value to return if parsing fails (default: {})
 * @returns The parsed JSON object or the fallback value
 */
export const safeJSONParse = <T = unknown>(jsonString: string, fallback: T = {} as T): T => {
  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return fallback;
  }
};

/**
 * Validates if a string is valid JSON.
 * @param jsonString - The string to validate
 * @returns true if valid JSON, false otherwise
 */
export const isValidJSON = (jsonString: string): boolean => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch {
    return false;
  }
};
